import { FC } from "react";
import { useContent } from "src/components/App/Content";

import "./HeroSection.scss";
import Button from "src/components/Form/Button";

const HeroSection: FC = () => {
  const content = useContent("rsvp-partner-network-page");
  const heroSection = content?.section;

  const imageBanner = heroSection?.media_slides?.[0]?.url ?? "";
  const logoBanner = heroSection?.media_slides?.[1]?.url ?? "";

  return (
    <section className="rsvp-partner-network-hero">
      <div className="hero-video-background">
        {heroSection?.videoDesktop?.url && (
          <video
            className="hero-video hero-video-desktop"
            autoPlay
            muted
            playsInline
            loop
          >
            <source src={heroSection.videoDesktop.url} type="video/mp4" />
          </video>
        )}
        {heroSection?.videoMobile?.url && (
          <video
            className="hero-video hero-video-mobile"
            autoPlay
            muted
            playsInline
            loop
          >
            <source src={heroSection.videoMobile.url} type="video/mp4" />
          </video>
        )}
      </div>
      <div className="container">
        <div className="content-wrapper">
          <div className="block block-content">
            <img src={logoBanner} alt="logo-banner" className="logo-banner" />
            <h1 className="main-title">{heroSection?.title}</h1>
            <img src={imageBanner} alt="hero-image" className="image-banner-mobile" />
            <p className="main-description">{heroSection?.text}</p>
          </div>

          <div className="block block-image">
            <img src={imageBanner} alt="hero-image" className="image-banner-desktop" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;